import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useConfig } from '@app/config';
import { gql, request } from 'graphql-request';
import { useNftMarketplaceFiltersState } from '@app/state/nftMarketplaceFiltersStore';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { AUCTION_STATUS } from '@app/constants/nftMarketplace';
import { add, subDays } from 'date-fns';
import { useAddress } from '@thirdweb-dev/react';
import { Token } from '@app/types/token';
import { omit } from 'lodash';

type PremiumListingOption = {
  nftContractAddress: string;
  token0: Token;
  token1: Token;
};

async function fetcher(apiUrl: string | undefined) {
  return null;

  if (!apiUrl) {
    return null;
  }

  const res = await request<{ listings: NFTMarketplaceListing[] }>(
    `${apiUrl}`,
    gql`
      query {
        listings(
          where: { isNFTAvailable: true, nftMetadata_: { isPremium: true } }
        ) {
          id
          type
          maker
          currency
          price
          tokenId
          reserve
          nftContractAddress
          amount
          start
          end
          isNFTAvailable
          token0 {
            id
            symbol
            name
            decimals
          }
          token1 {
            id
            symbol
            name
            decimals
          }
          nftPool {
            id
            lpToken {
              symbol
              name
              decimals
              id
            }
          }
          nftMetadata {
            isPremium
            id
          }
        }
      }
    `
  );

  return Object.values(
    res.listings.reduce<
      Record<
        string,
        { nftContractAddress: string; token0: Token; token1: Token }
      >
    >((res, item) => {
      if (!res[item.nftContractAddress]) {
        res[item.nftContractAddress] = {
          nftContractAddress: item.nftContractAddress,
          token0: {
            ...omit(item.token0, 'id'),
            contractAddress: item.token0.id,
            decimals: +item.token0.decimals
          },
          token1: {
            ...omit(item.token1, 'id'),
            contractAddress: item.token1.id,
            decimals: +item.token1.decimals
          }
        };
      }

      return res;
    }, {})
  );
}

export function usePremiumListingsOptions() {
  const config = useConfig();

  // todo - handle chain/dex here
  return useQuery<PremiumListingOption[] | null>(
    [
      QueryKeys.GET_NFT_MARKETPLACE_PREMIUM_LISTINGS_OPTIONS,
      config?.URLS.subgraphUrlNftMarketplace
    ],
    () => fetcher(config?.URLS.subgraphUrlNftMarketplace)
  );
}
